import Queue from "nq-js";

class DeleteSchemaUseCase {
  execute(collection) {
    return new Queue.Schema().delete(collection);
  }
}

export default DeleteSchemaUseCase;
